/**
 * Service-worker cache helpers (SEC-19).
 *
 * The service worker (public/service-worker.js) only caches public API
 * endpoints, so a current install never stores personal data. This purge is
 * defence-in-depth for two cases the allowlist alone doesn't cover:
 *   1. Shared device, same session — a logout should leave nothing readable via
 *      the Cache Storage API (which any same-origin script can read).
 *   2. Existing installs whose old SW version (mgr-v1) already cached
 *      /auth/me + /gardens before the user reloads and picks up the new worker.
 *
 * Runs from the page context (where `caches` is available), so it works even
 * when no SW controls the page yet. Cache-name-agnostic on purpose: it sweeps
 * every cache and removes only /api/ entries, leaving the app shell intact.
 */
export async function purgeApiCache() {
  if (typeof caches === 'undefined') return;

  try {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames.map(async name => {
        const cache = await caches.open(name);
        const requests = await cache.keys();
        await Promise.all(
          requests
            .filter(req => {
              try {
                return new URL(req.url).pathname.startsWith('/api/');
              } catch {
                return false;
              }
            })
            .map(req => cache.delete(req))
        );
      })
    );
  } catch {
    // Cache Storage unavailable or blocked — non-fatal; logout still proceeds.
  }
}
